import axios from "axios";
import { useEffect, useState } from "react";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : Array.isArray(d) ? d.map((x) => x.msg).join(", ") : e?.message || "Something went wrong";
};

export const imgUrl = (p) => (!p ? "" : p.startsWith("http") ? p : `${BACKEND_URL}${p}`);
export const imgSrcSet = (p) =>
  p && p.endsWith(".webp") && !p.startsWith("http")
    ? `${imgUrl(p.replace(/\.webp$/, "-sm.webp"))} 640w, ${imgUrl(p)} 1264w`
    : undefined;

const cache = new Map();
export const clearCache = () => cache.clear();

export function useFetch(path, nonce = 0) {
  const [state, setState] = useState(() => ({ data: cache.get(path), loading: !cache.has(path), error: null }));
  useEffect(() => {
    let alive = true;
    if (cache.has(path)) setState({ data: cache.get(path), loading: false, error: null });
    else setState((s) => ({ ...s, loading: true, error: null }));
    api
      .get(path)
      .then((r) => {
        cache.set(path, r.data);
        if (alive) setState({ data: r.data, loading: false, error: null });
      })
      .catch((e) => alive && setState((s) => ({ ...s, loading: false, error: e })));
    return () => {
      alive = false;
    };
  }, [path, nonce]);
  return state;
}
